export default "__VITE_ASSET__Ds8fNFnJ__"